import __request__ from "routing/request";
export function listContentPacks() {
  return __request__("GET", "/system/content_packs", null, {}, {
    "Accept": ["application/json"]
  });
}
export function createContentPack(Requestbody) {
  return __request__("POST", "/system/content_packs", Requestbody, {}, {
    "Accept": ["application/json"]
  });
}
export function listLatestContentPacks() {
  return __request__("GET", "/system/content_packs/latest", null, {}, {
    "Accept": ["application/json"]
  });
}
export function listContentPackRevisions(contentPackId) {
  return __request__("GET", `/system/content_packs/${contentPackId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteContentPack(contentPackId) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function listContentPackInstallationsById(contentPackId) {
  return __request__("GET", `/system/content_packs/${contentPackId}/installations`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteContentPackInstallationById(contentPackId, installationId) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}/installations/${installationId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function uninstallDetails(contentPackId, installationId) {
  return __request__("GET", `/system/content_packs/${contentPackId}/installations/${installationId}/uninstall_details`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getContentPackRevisions(contentPackId, revision) {
  return __request__("GET", `/system/content_packs/${contentPackId}/${revision}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function deleteContentPackBycontentPackIdAndrevision(contentPackId, revision) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}/${revision}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function downloadContentPackRevisions(contentPackId, revision) {
  return __request__("GET", `/system/content_packs/${contentPackId}/${revision}/download`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function installContentPack(contentPackId, revision, installationrequest) {
  return __request__("POST", `/system/content_packs/${contentPackId}/${revision}/installations`, installationrequest, {}, {
    "Accept": ["application/json"]
  });
}
